export var Moneyfarm2023ThemeDark = {
  id: 'mf-2023-dark',
  palette: {
    white: {
      main: '#ffffff'
    }
  },
  tokens: {
    space: {
      primary: {
        regular: '#0C0B0C '
      },
      secondary: {
        regular: '#18171C',
        gradient100: '#18171C',
        gradient0: '#0C0B0C'
      },
      tertiary: {
        regular: '#372A34',
        gradient100: '#372A34',
        gradient0: '#0C0B0C'
      },
      reversed: {
        regular: '#5B3552',
        gradient100: '#5B3552',
        gradient0: '#0C0B0C'
      },
      surface: {
        regular: '#18171C'
      },
      overlay: {
        regular: '#363636'
      },
      onOverlay: {
        regular: '#FFFFFF'
      }
    },
    accent: {
      token: {
        primary: {
          strong: '#A90E2D',
          regular: '#FF2E5B',
          light: '#D93657'
        },
        secondary: {
          strong: '#EFEBEE',
          regular: '#FFFFFF',
          light: '#736E72'
        }
      },
      onToken: {
        primary: {
          strong: '#FFFFFF',
          regular: '#FFFFFF',
          light: '#FFFFFF'
        },
        secondary: {
          strong: '#FFFFFF',
          regular: '#FFFFFF',
          light: '#FFFFFF'
        }
      },
      base: {
        primary: {
          strong: '#EFEBEE',
          regular: '#FFFFFF',
          light: '#736E72'
        },
        secondary: {
          strong: '#EFEBEE',
          regular: '#FFFFFF',
          light: '#736E72'
        }
      }
    },
    interface: {
      shadow: {
        strong: '#0000001F',
        regular: '#00000014',
        light: '#0000000A'
      },
      neutral: {
        strong: '#CECCCE',
        regular: '#747272',
        light: '#262325',
        lightest: '#262325'
      },
      feedback: {
        negative: {
          strong: '#F97F7F',
          regular: '#C51616',
          light: '#522323',
          lightest: '#522323'
        },
        positive: {
          strong: '#77CA89',
          regular: '#338445',
          light: '#23412A',
          lightest: '#23412A'
        },
        warning: {
          strong: '#FAA70F',
          regular: '#D28904',
          light: '#543F1C',
          lightest: '#543F1C'
        },
        info: {
          strong: '#50A0F7',
          regular: '#2D6EB4',
          light: '#21354C',
          lightest: '#21354C'
        },
        tip: {
          strong: '#D6CDD4',
          regular: '#AD9AA9',
          light: '#5B3552',
          lightest: '#5B3552'
        }
      },
      onFeedback: {
        strong: '#262325',
        regular: '#262325',
        light: '#FFFFFF',
        lightest: '#FFFFFF'
      }
    },
    feature: {
      primary: {
        strong: '#007B7B',
        regular: '#0B9F9F',
        light: '#14BCBC',
        lightest: '#F2FFFF'
      },
      secondary: {
        strong: '#384F74',
        regular: '#5273A6',
        light: '#7C9CD2',
        lightest: '#F3F8FF'
      },
      cash: {
        strong: '#E7E7E7',
        regular: '#CECCCE',
        light: '#747272',
        lightest: '#676565'
      },
      esg: {
        strong: '#93E3B5',
        regular: '#7DC69F',
        light: '#2C4939'
      },
      thematics: {
        strong: '#E7E7E7',
        regular: '#CECCCE',
        light: '#747272',
        lightest: '#676565'
      }
    },
    chart: {
      primary: {
        main: '#D6CDD4',
        child1: '#84687D',
        child2: '#5B3552'
      },
      secondary: {
        main: '#FF2E5B',
        child1: '#FFABBD',
        child2: '#7E2A3C'
      },
      tertiary: {
        main: '#DFD0BA',
        child1: '#8B7A60',
        child2: '#453D30'
      },
      stacked: {
        primary: '#7C9CD2',
        secondary: '#7AB6FA',
        tertiary: '#77CA89',
        fourth: '#CCB99D',
        fifth: '#93E3B5',
        sixth: '#FBA7A7',
        seventh: '#E388CF',
        eighth: '#FFE790',
        ninth: '#3BE1E1',
        tenth: '#FFC2CF',
        eleventh: '#BFB1BC',
        twelfth: '#E7E7E7'
      }
    },
    allocation: {
      bond: {
        main: '#14BCBC',
        child01: '#0B9F9F',
        child02: '#14BCBC',
        child03: '#3BE1E1',
        child04: '#53F9F9',
        child05: '#89FFFF'
      },
      equity: {
        main: '#D25CB8',
        child01: '#D25CB8',
        child02: '#E388CF'
      },
      other: {
        main: '#FFDC68',
        child01: '#F5CA2E',
        child02: '#FFDC68'
      }
    },
    text: {
      title: {
        regular: '#FFFFFF',
        light: '#CECCCE',
        lighter: '#747272',
        reversed: '#262325'
      },
      paragraph: {
        regular: '#FFFFFF',
        light: '#CECCCE',
        lighter: '#747272',
        reversed: '#262325'
      },
      label: {
        regular: '#FFFFFF',
        light: '#CECCCE',
        lighter: '#747272',
        reversed: '#262325',
        negative: '#F75A5A',
        positive: '#5ABF70',
        warning: '#FBB941',
        info: '#59A6F7',
        primary: '#FF2E5B',
        secondary: '#EFEBEE',
        tertiary: '#D6CDD4'
      }
    },
    spacing: {
      '2xs': '4px',
      xs: '8px',
      sm: '12px',
      md: '16px',
      lg: '24px',
      xl: '32px',
      '2xl': '40px',
      '3xl': '48px',
      '4xl': '64px',
      '5xl': '80px'
    }
  },
  typography: {
    font: {
      sizes: {
        small: 13,
        normal: 16,
        smedium: 18,
        medium: 21,
        big: 24,
        bigger: 38
      },
      weight: {
        normal: 400,
        semibold: 600
      },
      family: {
        title: 'Montserrat, Inter, Helvetica, Arial;',
        text: 'Inter, Helvetica, Arial;'
      },
      style: ['normal']
    }
  }
};